import * as React from "react";
import { forwardRef } from "react";
const SvgConversation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2 2H14V11H2.8775L2 11.8775V2ZM2 0.5C1.175 0.5 0.5075 1.175 0.5075 2L0.5 15.5L3.5 12.5H14C14.825 12.5 15.5 11.825 15.5 11V2C15.5 1.175 14.825 0.5 14 0.5H2ZM3.5 8H9.5V9.5H3.5V8ZM3.5 5.75H12.5V7.25H3.5V5.75ZM3.5 3.5H12.5V5H3.5V3.5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgConversation);
export { ForwardRef as ReactComponent };
